<template>
    <main-layout :showHeader="false" :showSidebar="false">
        <template slot="content">
            <div class="login">
                <div class="login__block active" id="l-login">
                    <img v-if="loginMessage.logo" :src="getBaseUrl+loginMessage.logo"/>
                    <div>
                        {{ $t('LBL_LOGIN_TITLE') }}
                        <div class="login__company-name">{{loginMessage.name}}</div>
                    </div>

                    <form class="login__block__body needs-validation p-1" @submit.prevent="onSubmit">
                        <base-field v-model="email" name="email" type="email" class="mt-3" :label="$t('LBL_USERNAME')"
                                    :isCentered="true"
                                    :mandatory="true" :isFloat="true"></base-field>
                        <base-field v-model="password" type="password" name="password" :label="$t('LBL_PASSWORD')"
                                    :mandatory="true" :isCentered="true" :isFloat="true"></base-field>

                        <div v-if="error" class="alert alert-danger" role="alert">
                            {{ error }}
                        </div>


                        <button type="submit" class="btn login__block__btn"><i
                                class="zmdi zmdi-refresh zmdi-hc-fw rotating" v-if="showLoader"></i> {{
                            $t('LBL_LOGIN_PAGE') }}
                        </button>
                        <div class="mt-5">
                            <router-link :to="{name: 'RequestAccess'}" class="float-left">{{
                                $t('LBL_REQUEST_ACCESS_TITLE') }}
                            </router-link>
                            <router-link :to="{name: 'PasswordRecovery'}" class="float-right">{{
                                $t('LBL_RESET_PASSWORD_TITLE') }}
                            </router-link>
                        </div>
                    </form>
                </div>
            </div>
        </template>
    </main-layout>
</template>

<script>
    import AppHelper from "../helper"
    import { getEnvVar } from '@/utils/env'

    export default {
        computed: {
            getBaseUrl() {
               return getEnvVar('VUE_APP_BASE_URL')
            }
        },
        data() {
            return {
                email: '',
                password: '',
                error: '',
                showLoader: false,
                loginMessage: ''
            }
        },

        components: {
            'base-field': () => import('@/components/form_elements/Base'),
            'main-layout': () => import('@/layout/Main'),
        },

        $_veeValidate: {validator: "new"},

        methods: {
            async onSubmit() {
                await this.$validator.validateAll()

                if (!this.errors.any() && !this.showLoader) {

                    this.showLoader = true
                    var response = await Api.login(this.email, this.password)
                    this.showLoader = false

                    if (!response.success) {
                        this.error = response.error.label
                    } else {
                        // Get path to redirect after login
                        var path = this.$store.state.redirect.path

                        if (!AppHelper.empty(path)) {
                            // Resets redirect path
                            this.$store.commit('setRedirect', {})
                            this.$router.replace({path: path})
                        } else {
                            await this.$store.dispatch('fetchStructure')
                            if (this.$store.getters.getStructure.access.client_portal) {
                                this.$router.push({path: '/HelpDesk/Index'})
                            } else {
                                this.$router.push({path: '/GDPR/Index'})
                            }
                        }
                    }
                }
            }
        },

        async mounted() {
            var response = await Api.getLoginData()
            if (response.success) {
                this.loginMessage = response.result.company_info
            }
        },

        beforeRouteEnter(to, from, next) {
            if (Api.isAuthenticated()) {
                next({name: 'Dashboard'})
            } else {
                next()
            }
        }
    }
</script>
<style lang="scss">@import "@/assets/scss/pages/_login.scss";</style>